module.exports = __webpack_public_path__ + "img/1512937874.da391c81.jpg";